import { Typography } from "@stardust-ds/react"
import intl from "react-intl-universal"

import styles from "./index.module.scss"
import Modal from "../Modal"
import Button from "../../atoms/Button"
import EvidenceTextList from "../EvidenceTextList"
import RcmpLoading from "../../atoms/Loading"

function RcmpInteractions(props) {
  const { aInteractions, bLoading, cErrorMessage } = props

  if (bLoading)
    return <RcmpLoading bShow={true} className={styles.loadingContainer} />

  if (cErrorMessage)
    return (
      <Typography className={styles.errorMessage} type="h5" color="#415364">
        {cErrorMessage}
      </Typography>
    )

  return (
    <EvidenceTextList
      gap={32}
      aData={aInteractions}
      cDataFieldName={intl.get("board.interaction_date")}
      bShowActionButtons={false}
    />
  )
}

export default function RcmpModalInteractions(props) {
  const { bIsOpen, fnOnClose, cTitle, aInteractions, bLoading, cErrorMessage } =
    props

  const fnOnRequestClose = () => {
    fnOnClose?.()
  }

  return (
    <Modal isOpen={bIsOpen} size="lg" onRequestClose={fnOnRequestClose}>
      <Modal.Header onClose={fnOnClose}>{cTitle}</Modal.Header>
      <Modal.Content>
        <RcmpInteractions
          aInteractions={aInteractions}
          bLoading={bLoading}
          cErrorMessage={cErrorMessage}
        />
      </Modal.Content>
      <Modal.Footer size="lg" style={{ justifyContent: "flex-end" }}>
        <Button onClick={fnOnClose}>{intl.get("close")}</Button>
      </Modal.Footer>
    </Modal>
  )
}
